<template>
  <div class="slider-form slider-form--care-home">
    <transition name="fade">
      <div class="slider-form__item" v-if="slideNo === 1">
        <h3 class="slider-form__header slider-form__header--care-home text-center">What level of care do you need?</h3>

        <div class="radio-container radio-container--type">
          <div
            v-for="option in slide1Options"
            class="radio-group radio-group--type"
            :class="{ 'radio-group--active': levelOfCare === option.value }"
            @click="submitSlide(2, 'levelOfCare', option.value)">
            <input
              type="radio"
              :id="makeIdValue(option.name)"
              name="levelOfCare"
              :value="option.value"
              v-model="levelOfCare">
            <label :for="makeIdValue(option.name)" :class="{ 'active': levelOfCare === option.value }">
              <i :class="getLevelOfCareIconClass(option.icon, option.value, 'levelOfCare' )"></i>
              <span v-html="option.name"></span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="slider-form__item" v-if="slideNo === 2">
        <h2 class="text-center">Let us help you</h2>
        <h3 class="slider-form__header slider-form__header--care-home text-center">How soon is care needed?</h3>

        <div class="radio-container radio-container--type">
          <div
            v-for="option in slide2Options"
            class="radio-group radio-group--type"
            :class="{ 'radio-group--active': timeFrame === option.name }"
            @click="submitSlide(3, 'timeFrame', option.name)">
            <input type="radio" :id="makeIdValue(option.name)" name="timeFrame" :value="option.name" v-model="timeFrame">
            <label :for="makeIdValue(option.name)" :class="{ 'active': timeFrame === option.name }">
              <i :class="getLevelOfCareIconClass(option.icon, option.name, 'timeFrame' )"></i>
              <span v-html="option.name"></span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="slider-form__item" v-if="slideNo === 3">
        <h2 class="text-center">Let us help you</h2>
        <h3 class="slider-form__header slider-form__header--care-home text-center">Do you have a room preference?</h3>

        <div class="radio-container radio-container--type radio-container--loc">
          <div
            v-for="option in slide3Options"
            class="radio-group radio-group--type"
            :class="{ 'radio-group--active': isCheckboxChecked(option.name, 'rooms') }"
            @click="clickCheckBoxLabel"
          >
            <input
              type="checkbox"
              class="checkbox"
              :id="makeIdValue(option.name)"
              name="rooms[]"
              :value="option.name"
              v-model="data.rooms">
            <label :for="makeIdValue(option.name)" :class="{ 'active': isCheckboxChecked(option.name, 'rooms') }">
              <i :class="getIconClassArray(option.icon, option.name, 'rooms' )"></i>
              <span v-html="option.name"></span>
            </label>
          </div>
          <button name="next" class="btn btn--green" :disabled="data.rooms.length === 0" @click.prevent="nextSlide(4)">Next step</button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="slider-form__item" v-if="slideNo === 4">
        <h2 class="text-center">Let us help you</h2>
        <h3 class="slider-form__header slider-form__header--care-home text-center">Do you have a preference on the rest home size?</h3>

        <div class="radio-container radio-container--type">
          <div
            v-for="option in slide4Options"
            class="radio-group radio-group--type"
            :class="{ 'radio-group--active': homeSize === option.name }"
            @click="submitSlide(5, 'homeSize', option.name)">
            <input type="radio" :id="makeIdValue(option.name)" name="homeSize" :value="option.name" v-model="homeSize">
            <label :for="makeIdValue(option.name)" :class="{ 'active': homeSize === option.name }">
              <i :class="getLevelOfCareIconClass(option.icon, option.name, 'homeSize' )"></i>
              <span v-html="option.name"></span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="slider-form__item" v-if="slideNo === 5">
        <h2 class="text-center">Let us help you</h2>
        <h3 class="slider-form__header slider-form__header--care-home text-center">
          Has the person going into care completed a <br class="d-none d-lg-block">needs assessments?
        </h3>

        <div class="radio-container radio-container--type">
          <div
            v-for="option in slide5Options"
            class="radio-group radio-group--type"
            :class="{ 'radio-group--active': assessment === option.name }"
            @click="submitSlide(6, 'assessment', option.name)">
            <input type="radio" :id="makeIdValue(option.name)" name="assessment" :value="option.name" v-model="assessment">
            <label :for="makeIdValue(option.name)" :class="{ 'active': assessment === option.name }">
              <i :class="getLevelOfCareIconClass(option.icon, option.name, 'assessment' )"></i>
              <span v-html="option.name"></span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="slider-form__item" v-show="slideNo === 6">
        <h2 class="text-center">Let us help you</h2>
        <h3 class="slider-form__header slider-form__header--care-home text-center">Where are you looking?</h3>
        <div class="villages__filter">
          <region-dropdown
            id="region_list"
            class="dropdown--village dropdown--full-width"
            :empty-string="'Select region'"
            icon-class="icon--arrow-down"
          ></region-dropdown>
        </div>
        <div class="villages__filter">
          <district-dropdown
            id="district_list"
            class="dropdown--village dropdown--full-width"
            :empty-string="'Select district'"
            icon-class="icon--arrow-down"
            :districts="[]"
            :default-type="'careHome'"
          ></district-dropdown>
        </div>
        <div class="slider-form__suburbs">
          <select-checkbox
            icon-class="icon--arrow-down"
            class="dropdown--village dropdown--full-width"
            :empty-string="'Select suburbs'"
          >
          </select-checkbox>
        </div>
        <button name="next" class="btn btn--green" @click.prevent="addressStep">Next step</button>
      </div>
    </transition>
    <Form
      method="POST"
      class="ml-auto mr-auto"
      :validation-schema="validationSchema"
      v-slot="{ errors }"
      @submit="submitRequest"
      id="careHomeHelp"
    >
      <transition name="fade">
        <div class="slider-form__item" v-if="slideNo === 7">
          <h2 class="text-center">Let us help you</h2>
          <h3 class="slider-form__header slider-form__header--care-home text-center">What email address should we send suggested rest homes to?</h3>
          <label for="email" class="sr-only">Email</label>
          <Field
            id="email"
            v-model="inputEmail"
            type="text"
            placeholder="Your email address ..."
            class="form-control slider-form__input"
            :class="{'is-danger': errors['email'] }"
            name="email"
          />
          <ErrorMessage name="email" class="is-danger" />
          <button name="next" class="btn btn--green" type="submit">Next step</button>
        </div>
      </transition>
      <transition name="fade">
        <div class="slider-form__item" v-if="slideNo === 8">
          <h2 class="text-center">Let us help you</h2>
          <h3 class="slider-form__header slider-form__header--care-home text-center">Thank you, what is your name?</h3>
          <label for="name" class="sr-only">Name</label>
          <Field
            id="name"
            v-model="inputName"
            type="text"
            placeholder="Your name ..."
            class="form-control slider-form__input"
            :class="{'is-danger': errors['name'] }"
            name="name"
          />
          <ErrorMessage name="name" class="is-danger mb-4 text-left" />
          <button name="next" class="btn btn--green" type="submit">Next step</button>
        </div>
      </transition>
      <transition name="fade">
        <div class="slider-form__item" v-if="slideNo === 9">
          <h2 class="text-center">Let us help you</h2>
          <h3 class="slider-form__header slider-form__header--care-home text-center">Thanks {{ inputName }}, are there any other notes you’d like to add?</h3>
          <label for="message" class="sr-only">Your message</label>
          <textarea
            id="message"
            v-model="inputMessage" type="text"
            placeholder="Your message ..."
            rows="5"
            class="form-control slider-form__input slider-form__input--textarea"
            name="message" autocomplete="off"></textarea>
          <button name="next" class="btn btn--green" type="submit">Next step</button>
        </div>
      </transition>
      <transition name="fade">
        <div class="slider-form__item" v-if="slideNo === 10">
          <h2 class="text-center">Let us help you</h2>
          <h3 class="slider-form__header slider-form__header--care-home text-center">Finally {{ inputName }}, what's the best number to contact you on if we need further information?</h3>
          <label for="phone" class="sr-only">Phone number</label>
          <Field
            id="phone"
            v-model="inputPhone"
            type="text"
            placeholder="Your contact phone number ..."
            class="form-control slider-form__input"
            :class="{'is-danger': errors['phone'] }"
            name="phone"
          />
          <ErrorMessage name="phone" class="is-danger mb-4" />
          <button name="next" class="btn btn--green fs-20" type="submit">View suggested Rest Homes</button>
        </div>
      </transition>
      <a href="#" @click.prevent="back" v-if="slideNo > 1 && slideNo < 10" class="slider-form__back-link">Back</a>
      <div class="slider-form__progress-light-green">
        <div class="slider-form__progress-green" :style="{ width: percentage + '%' }"></div>
      </div>
    </Form>
  </div>
</template>

<script setup>
import {computed, reactive, ref, watch} from 'vue'
import {ErrorMessage, Field, Form} from 'vee-validate'
import axios from 'axios';
import regionDropdown from '../ListingPages/RegionDropdown.vue'
import districtDropdown from '../ListingPages/DistrictDropdown.vue'
import selectCheckbox from '../Global/SelectCheckbox.vue'
import useFilterStore from '../../store/filterStore'

const validationSchema = computed(() => {
  let schema = {}

  if (slideNo.value === 7) {
    schema.email = 'required|email'
  }

  if (slideNo.value === 8) {
    schema.name = 'required'
  }

  return schema
})

const levelOfCare = ref('');
const timeFrame = ref('');
const homeSize = ref('');
const assessment = ref('');
const inputEmail = ref('');
const emailSentTime = ref('');
const inputName = ref('');
const inputSuburb = ref([]);
const inputMessage = ref('');
const inputPhone = ref('');
const slideNo = ref(1);
const percentage = ref(10);
const filterStore = useFilterStore()

const data = reactive({
  rooms: [],
});

const slide1Options = ref([
  {
    'name': 'Rest home',
    'value': 'Rest home care',
    'icon': 'icon-rest-home',
  },
  {
    'name': 'Hospital',
    'value': 'Hospital care',
    'icon': 'icon-hospital',
  },
  {
    'name': 'Dementia',
    'value': 'Dementia care',
    'icon': 'icon-dementia',
  }, {
    'name': 'Respite',
    'value': 'Respite care',
    'icon': 'icon-respite',
  },
  {
    'name': 'Day care',
    'value': 'Day care',
    'icon': 'icon-day-care',
  },
  {
    'name': 'Unsure',
    'value': 'Unsure',
    'icon': 'icon-unsure',
  },
]);

const slide2Options = ref([
  {
    'name': 'Immediately',
    'icon': 'icon-hourglass',
  },
  {
    'name': 'Within 2 weeks',
    'icon': 'icon-calendar',
  },
  {
    'name': 'Within 4 weeks',
    'icon': 'icon-calendar',
  },
  {
    'name': '4+ weeks',
    'icon': 'icon-calendar',
  },
]);

const slide3Options = ref([
  {
    'name': 'Unsure at this stage',
    'icon': 'icon-tick',
  },
  {
    'name': 'Room with an ensuite',
    'icon': 'icon-tick',
  },
  {
    'name': 'Room with extra space',
    'icon': 'icon-tick',
  },
  {
    'name': 'Room with outdoor access',
    'icon': 'icon-tick',
  },
]);

const slide4Options = ref([
  {
    'name': 'Fewer than 50 beds',
    'icon': 'icon-bed',
  },
  {
    'name': 'Fewer than 100 beds',
    'icon': 'icon-bed',
  },
  {
    'name': 'This isn\'t important',
    'icon': '',
  },
]);

const slide5Options = ref([
  {
    'name': 'Yes',
    'icon': 'icon-clipboard-tick',
  },
  {
    'name': 'Have begun the process',
    'icon': 'icon-clipboard-lines',
  },
  {
    'name': 'Not at this stage',
    'icon': 'icon-clipboard-dots',
  },
]);

watch(
  () => slideNo.value,
  (newSlideNo) => {
    calculatePercentage();
  }
);
const submitSlide = (nextSlideNo, inputModalName, value = '') => {
  slideNo.value = nextSlideNo;
  if (value !== '') {
    data[inputModalName] = value;
  }
  calculatePercentage();
};

const isCheckboxChecked = (value, inputModalName) => {
  return (data[inputModalName].indexOf(value) !== -1);
};

const clickCheckBoxLabel = (e) => {
  // click label
  if (e.target.getElementsByClassName('checkbox')[0] !== undefined) {
    e.target.getElementsByClassName('checkbox')[0].click();
  }
};

const addressStep = () => {
  slideNo.value = 7;
  calculatePercentage();
};

const nextSlide = (nextSlideNo) => {
  slideNo.value = nextSlideNo;
  calculatePercentage();
};

const validateStep = (nextSlideNo) => {
  // Vue.$validator.validateAll().then((result) => {
  //   if (result) {
  //     slideNo.value = nextSlideNo;
  //     calculatePercentage();
  //   }
  // });
};

const submitRequest = () => {
  if (slideNo.value !== 10) {
    slideNo.value = slideNo.value + 1;
  } else {
    calculatePercentage()
    const region = filterStore.region.id
    const district = filterStore.district.id
    const suburbs = filterStore.suburbs
    let url = `/rest-homes/suggested?loc=${levelOfCare.value}&time=${timeFrame.value}&size=${homeSize.value}`;
    url = url + `&region=${region}&district=${district}&assessment=${assessment.value}&rest=1`;

    if (suburbs.length > 0) {
      url = url + `&suburbs=${JSON.stringify(suburbs)}`;
    }

    if (data.rooms.length > 0) {
      url = url + `&rooms=${JSON.stringify(data.rooms)}`;
    }

    localStorage.setItem('suggestedEmail', inputEmail.value);
    localStorage.setItem('suggestedName', inputName.value);
    localStorage.setItem('suggestedMsg', inputMessage.value);
    localStorage.setItem('suggestedPhone', inputPhone.value);
    window.location = url;
  }
};

const back = () => {
  slideNo.value = slideNo.value - 1;
  calculatePercentage();
};

const calculatePercentage = () => {
  percentage.value = (slideNo.value * 10);
};

const close = () => {
  $emit('close');
};

const makeIdValue = (value) => {
  return value.toLowerCase().replace(/ /g, '_');
};

const getLevelOfCareIconClass = (icon, name, inputModalName) => {
  const iconActive = (data[inputModalName] === name) ? `${icon}--active` : '';

  return `${icon} ${iconActive}`;
};

const getIconClassArray = (icon, value, inputModalName) => {
  const iconActive = (data[inputModalName].indexOf(value) !== -1) ? `${icon}--active` : '';

  return `${icon} ${iconActive}`;
};

</script>
